<script setup lang="ts">
import { computed } from 'vue';
import Icon from '../icon/icon.vue';
import { IconName, IconSize } from '../icon/icon.constants';
import {
  FileKind,
  getFileKind,
  getFileKindByExtension,
} from '../../utils/file';

type Props = {
  /** File name (or URL basename) whose extension picks the glyph. */
  fileName: string;
  /** Overrides the extension derived from fileName, e.g. when fileName is a display title. */
  extension?: string;
};

const props = defineProps<Props>();

const iconByFileKind: Record<FileKind, IconName> = {
  [FileKind.PDF]: IconName.FILE_PDF,
  [FileKind.IMAGE]: IconName.FILE_IMAGE,
  [FileKind.VIDEO]: IconName.FILE_VIDEO,
  [FileKind.AUDIO]: IconName.FILE_AUDIO,
  [FileKind.PRESENTATION]: IconName.FILE_PRESENTATION,
  [FileKind.DOCUMENT]: IconName.FILE_DOCUMENT,
  [FileKind.OTHER]: IconName.FILE_DOCUMENT,
};

const iconName = computed(
  () =>
    iconByFileKind[
      props.extension
        ? getFileKindByExtension(props.extension)
        : getFileKind(props.fileName)
    ],
);
</script>

<template>
  <div
    class="flex h-5xl w-5xl shrink-0 items-center justify-center rounded-md bg-info-container text-info"
  >
    <Icon :name="iconName" :size="IconSize.LG" />
  </div>
</template>
